import { Resources, useResource } from "Translations/Resources";
import { Box, Button, Stack } from "@mui/material";
import { NotificationVariant } from "Infrastructure/Api/Api";

const RESOURCES = Resources.Common;

type Props = {
  variant: NotificationVariant;
  onEdit?: () => void;
  onRestore?: () => void;
  onDelete?: () => void;
};

export const NotificationControls = ({
  variant,
  onEdit,
  onRestore,
  onDelete,
}: Props) => {
  const { t } = useResource();
  const isCritical = variant === NotificationVariant.Critical;
  const stackColor = isCritical ? "common.white" : undefined;
  const actionColor = isCritical ? "inherit" : "primary";
  const deleteColor = isCritical ? "inherit" : "error";

  return (
    <Stack px={2} color={stackColor}>
      <Box display="flex" gap={1} justifyContent="flex-end">
        {onEdit && (
          <Button
            variant="text"
            color={actionColor}
            size="small"
            onClick={onEdit}
          >
            {t(RESOURCES.Edit)}
          </Button>
        )}
        {onRestore && (
          <Button
            variant="text"
            color={actionColor}
            size="small"
            onClick={onRestore}
          >
            {t(RESOURCES.Restore)}
          </Button>
        )}
        {onDelete && (
          <Button
            variant="text"
            color={deleteColor}
            size="small"
            onClick={onDelete}
          >
            {t(RESOURCES.Delete)}
          </Button>
        )}
      </Box>
    </Stack>
  );
};
